import React from 'react';
import { useDisclosure } from '@cardboard-ui/react';
import { OptionsMenu } from 'components/OptionsMenu';
import { ItemMenuButton } from '../ItemMenuButton';
import { RenameOption } from 'components/OptionsMenu/options/RenameOption';
import { DeleteNodeOption } from 'components/OptionsMenu/options/DeleteNodeOption';
import { MoveOption } from 'components/OptionsMenu/options/MoveOption';
import { EditOption } from 'components/OptionsMenu/options/EditOption';
import { DuplicateOption } from 'components/OptionsMenu/options/DuplicateOption';
import { PinOption } from 'components/OptionsMenu/options/PinOption';
import { ItemMenuProps } from '../../ItemMenu';
import { AccessOption } from 'components/OptionsMenu/options/AccessOption';
import { RequestSignaturesOption } from 'components/OptionsMenu/options/RequestSignaturesOption';
import { AddTagsOption } from 'components/OptionsMenu/options/AddTagsOption';
import { AnnounceOption } from 'components/OptionsMenu/options/AnnounceOption';
import { CreateShortcutOption } from 'components/OptionsMenu/options/CreateShortcutOption';
import { ThumbnailOption } from 'components/OptionsMenu/options/ThumbnailOption';
import { FavouriteOption } from 'apps/TenantApp/screens/Favourites/components/FavouriteButton';
import { ManageVaultFieldsOption } from 'apps/TenantApp/screens/Vaults/components/ManageVaultFieldsOption';
import { MarkAsOption } from 'components/OptionsMenu/options/MarkAsOption';

interface ItemOptionsMenuProps extends ItemMenuProps {}

export const ItemOptionsMenu = ({
  node,
  connectionId,
  onCompletedDelete,
  inPinnableContext,
  isTaggableContext = true,
}: ItemOptionsMenuProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  if (!node) return null;

  return (
    <OptionsMenu
      button={<ItemMenuButton onClick={onOpen} />}
      isOpen={isOpen}
      onClose={onClose}
    >
      {isTaggableContext && <AddTagsOption nodeId={node.id} />}
      <FavouriteOption node={node} />
      <AnnounceOption node={node} />
      <CreateShortcutOption node={node} />
      <RenameOption node={node} />
      <ThumbnailOption node={node} />
      <RequestSignaturesOption node={node} />
      {inPinnableContext && <PinOption node={node} />}
      <DuplicateOption node={node} connectionId={connectionId} />
      <EditOption node={node} />
      <MarkAsOption node={node} />
      <MoveOption node={node} connectionId={connectionId} />
      <AccessOption node={node} />
      <ManageVaultFieldsOption node={node} />
      <DeleteNodeOption
        node={node}
        connectionId={connectionId}
        onCompleted={onCompletedDelete}
      />
    </OptionsMenu>
  );
};
